import { getSearchField, getSearchType } from "constant/search";
import { getOrder } from "constant/order";
import { ALL_MONTHS, getMonths } from "constant/month";
import { isMobile } from "react-device-detect";
import { useSelector } from "react-redux";

import useLocationParams from "components/hook/useLocationParams";
import { numberCommaString, parseBoolean, localStorageFactory, getSessionItem } from "helpers";

const useSearchParams = (pageType = "post") => {
	// 검색 데이터 조회

	// 캐치 모바일 보여주는 페이지 동영상 개수 다르게 적용
	const per_page = (pageType==="catch" && isMobile) || (pageType==="catchstory" && isMobile) ? "21" : "20";
	const {
		param: { page = "1", perPage = per_page , keyword = "", field, orderBy, type, months = ALL_MONTHS },
	} = useLocationParams();

	const isLogin = useSelector(({ authenticationReducer }) => authenticationReducer.is_login);

	// 페이징 필터링
	let filteredPage = parseInt(page);
	(isNaN(page) || !filteredPage) && (filteredPage = 1);

	// 노출 갯수 필터링
	let filteredPerPage = parseInt(perPage);
	(isNaN(filteredPerPage) || !filteredPerPage) && (filteredPerPage = 20);

	// 검색어 필터링
	const filteredKeyword = keyword.trim();

	// 검색 필드 필터링
	const filteredField = getSearchField(field, pageType);

	// 정렬 필터링
	let catchCreated = localStorageFactory.getItem("catchCreated") || true;
	catchCreated = parseBoolean(catchCreated);
	
	/**
	 * localStorage 정렬 옵션 조회
	 */
	const storageOrderBy = () => {
		let storageOrder = "";
		let keepOrder = getSessionItem('keep_order') || '';

		if(isLogin && keepOrder) {
			keepOrder = keepOrder.map((order) => {
				let typeOrder = JSON.parse(order);
				if(Object.keys(typeOrder)[0] === pageType) {
					storageOrder = Object.values(typeOrder)[0];
				} 
			});

		}
		
		return storageOrder;
	};

	let storageOrder = storageOrderBy();
	storageOrder = storageOrder ? storageOrder : orderBy;

	const filteredOrder = getOrder(storageOrder, filteredField, pageType, catchCreated);
	
	// 검색 게시글 종류 필터링
	const filteredType = getSearchType(type);

	// 검색 시작 날짜 필터링
	const filteredMonths = getMonths(months);

	return {
		page: filteredPage,
		perPage: filteredPerPage,
		keyword: filteredKeyword,
		field: filteredField,
		orderBy: filteredOrder,
		type: filteredType,
		months: filteredMonths,
	};
};

export default useSearchParams;
